/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

const CLARITY_SCRIPT_ID = 'ms-clarity-script';

const getClarityApi = () => globalThis.clarity;

export class Clarity {
  public static init(projectId) {
    if (!projectId || document.getElementById(CLARITY_SCRIPT_ID)) {
      return;
    }

    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.id = CLARITY_SCRIPT_ID;
      t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(globalThis, document, 'clarity', 'script', projectId);
  }

  public static enable(projectId) {
    this.init(projectId);
    this.updateConsent(true);
  }

  public static disable() {
    this.updateConsent(false);
  }

  private static updateConsent(isGranted) {
    const clarity = getClarityApi();
    if (!clarity) {
      return;
    }

    clarity('consentv2', {
      ad_Storage: 'denied',
      analytics_Storage: isGranted ? 'granted' : 'denied',
    });

    if (!isGranted) {
      clarity('consent', false);
    }
  }
}
